<div class="banner">
    <img [src]="img1" alt="Banner" class="img-fluid">
</div>